export default {
  App: "/",
  requestGridPath: "/request",
  requestCreatePath: "/request/create",
  requestUpdatePath: "/request/edit/:id",
  requestDetailPath: "/request/detail/:id",
  reportDistributionDetailPath: "/report-distribution/detail/:id",
  reportChecklist: "/reportChecklist",
  resetPasswordPath: "/resetPassword",
  signContract: "sign-contract/:id",
  notificationPath: "/notification",
} as const;
